import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "kn-list--column p-col-4 p-sm-4 p-md-3 p-p-0" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-router-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_FabButton = _resolveComponent("FabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnListBox = _resolveComponent("KnListBox")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loadingVersion)
      ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
          key: 0,
          class: "kn-progress-spinner"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_FabButton, {
              icon: "fas fa-plus",
              onClick: _ctx.showDetail,
              "data-test": "open-form-button"
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_KnListBox, {
          options: _ctx.listOfDatasets,
          settings: _ctx.mainDescriptor.knListSettings,
          onClick: _ctx.showDetail,
          onClone: _withModifiers(_ctx.emitCloneDataset, ["stop"]),
          onDelete: _withModifiers(_ctx.deleteDataset, ["stop"])
        }, null, 8, ["options", "settings", "onClick", "onClone", "onDelete"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_view, {
          scopeTypes: _ctx.scopeTypes,
          categoryTypes: _ctx.categoryTypes,
          datasetTypes: _ctx.datasetTypes,
          transformationDataset: _ctx.transformationDataset,
          scriptTypes: _ctx.scriptTypes,
          dataSources: _ctx.dataSources,
          businessModels: _ctx.businessModels,
          pythonEnvironments: _ctx.pythonEnvironments,
          rEnvironments: _ctx.rEnvironments,
          metaSourceResource: _ctx.metaSourceResource,
          datasetToCloneId: _ctx.datasetToCloneId,
          availableTags: _ctx.tags,
          onLoadingOlderVersion: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadingVersion = true)),
          onOlderVersionLoaded: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadingVersion = false)),
          onTouched: _cache[3] || (_cache[3] = ($event: any) => (_ctx.touched = true)),
          onCreated: _ctx.onCreate,
          onUpdated: _ctx.onUpdate,
          onShowSavingSpinner: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadingVersion = true)),
          onHideSavingSpinner: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadingVersion = false)),
          onClose: _ctx.closeDetailConfirm
        }, null, 8, ["scopeTypes", "categoryTypes", "datasetTypes", "transformationDataset", "scriptTypes", "dataSources", "businessModels", "pythonEnvironments", "rEnvironments", "metaSourceResource", "datasetToCloneId", "availableTags", "onCreated", "onUpdated", "onClose"])
      ])
    ])
  ]))
}